<script setup lang="ts">
import { Button, Icon } from "@/components/ui"
import { useTranslation } from "@/composables"
import { UnauthorizedLayout } from "@/layouts"

interface AuthErrorHandlerProps {
  title?: string
  defaultMessage?: string
  onRetry?: () => void
}

defineProps<AuthErrorHandlerProps>()

const { t } = useTranslation()
</script>

<template>
  <UnauthorizedLayout>
    <div class="flex items-center justify-center">
      <div class="max-w-md w-full space-y-8 p-6">
        <div class="text-center flex flex-col items-center">
          <Icon icon="Caution" size="2xl" class="fill-red-700 text-red-700 mb-5" />
          <h2 class="text-2xl font-bold font-comfortaa mb-2">
            {{ title || t("auth_error_handler.title") }}
          </h2>
          <p class="text-label mb-6 font-montserrat">
            {{ defaultMessage || t("auth_error_handler.default_message") }}
          </p>
          <Button
            v-if="onRetry"
            class="w-full flex justify-center"
            variant="primary"
            @click="onRetry"
          >
            {{ t("auth_error_handler.retry_btn") }}
          </Button>
        </div>
      </div>
    </div>
  </UnauthorizedLayout>
</template>
